<template>
    <div class="container-footer-home">
        <div class="wrapper-footer">
            <div
                id="footer-mainmenu-tab"
                class="icon-mainMenu"
                v-for="item in menuFooter"
                :key="item.id"
                @click="onClickTab(item)"
            >
                <a :href="setHref" :crm_at="'icon_mainMenu_' + item.id">
                    <img
                        :src="
                            setTab === item.activeTab
                                ? item.activeImg
                                : item.iconImg
                        "
                        class="image-icon-footer"
                    />
                    <div
                        class="font-mainMenu"
                        :class="
                            setTab === item.activeTab ? 'font-active-tab' : ''
                        "
                    >
                        {{ item.menuText }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import iconMenuActive1 from "@/assets/icon/home-icon-active@2x.png";
import iconMenuActive2 from "@/assets/icon/voucher_active.svg";
import iconMenuActive3 from "@/assets/icon/menu-icon-active@2x.png";
import iconMenuActive4 from "@/assets/icon/profile-icon-active@2x.png";
import iconMenu1 from "@/assets/icon/home-icon-new-theme.svg";
import iconMenu2 from "@/assets/icon/voucher_non_active.svg";
import iconMenu3 from "@/assets/icon/menu-icon-new-theme.svg";
import iconMenu4 from "@/assets/icon/profile-icon-news-theme.svg";

export default {
    name: "Footer",
    components: {},

    props: {
        settabactive: String,
    },
    data: function () {
        return {
            setTab: this.settabactive,
            setHref: null,
            menuFooter: [],
        };
    },
    created: function () {
        this.setMenuFunction();
    },
    methods: {
        setMenuFunction() {
            const objMenu = [
                {
                    id: 1,
                    iconImg: iconMenu1,
                    activeImg: iconMenuActive1,
                    activeTab: "privilege",
                    menuText: "หน้าหลัก",
                    href: "privilege",
                },
                {
                    id: 2,
                    iconImg: iconMenu2,
                    activeImg: iconMenuActive2,
                    activeTab: "voucher",
                    menuText: "แลกของรางวัล",
                    href: "voucher",
                },
                {
                    id: 3,
                    iconImg: iconMenu3,
                    activeImg: iconMenuActive3,
                    activeTab: "menu",
                    menuText: "เมนู",
                    href: "menu",
                },
                {
                    id: 4,
                    iconImg: iconMenu4,
                    activeImg: iconMenuActive4,
                    activeTab: "profile",
                    menuText: "โปรไฟล์",
                    href: "profile",
                },
            ];
            this.menuFooter = objMenu;
        },
        onClickTab(item) {
            if (window.location.pathname !== `/${item.href}`) {
                this.$router.push(item.href);
                this.setTab = item.activeTab;
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/style/_mixin.scss";
.container-footer-home {
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 480px;
    margin: auto;
    z-index: 100;
    .wrapper-footer {
        display: flex;
        background-color: $color-brown-900;
        padding-top: 0.75rem;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-bottom: 10px;
        cursor: pointer;
        .icon-mainMenu {
            width: 25%;
            display: flex;
            justify-content: center;
            padding: 0 5px;
            .image-icon-footer {
                width: 27px;
                height: 27px;
            }
            .font-mainMenu {
                color: $color-brown-700;
                font-size: 14px;
                white-space: nowrap;
            }
            .font-active-tab {
                color: #ffffff;
                font-size: 14px;
            }
        }
        .icon-mainMenu a {
            text-align: center;
        }
    }
}
</style>
